import { Star } from "lucide-react";

interface RatingStarsProps {
  value: number | null | undefined;
  variant?: "compact" | "min" | "full";
  size?: "xs" | "sm" | "md";
  reviews_count?: number | null;
}

const getReviewWord = (count: number): string => {
  const lastTwo = count % 100;
  const lastOne = count % 10;

  if (lastTwo >= 11 && lastTwo <= 14) return "отзывов";
  if (lastOne === 1) return "отзыв";
  if (lastOne >= 2 && lastOne <= 4) return "отзыва";
  return "отзывов";
};

export function RatingStars({
  value,
  variant = "full",
  size = "sm",
  reviews_count,
}: RatingStarsProps) {
  const ratingNum = typeof value === "number" ? value : Number(value || 0);
  const safe = isNaN(ratingNum) ? 0 : Math.max(0, Math.min(5, ratingNum));
  const starSize = size === "xs" ? 11 : size === "sm" ? 14 : 18;
  const textSize =
    size === "xs" ? "text-[10px]" : size === "sm" ? "text-xs" : "text-sm";

  // Делим на 10 частей: каждая звезда = 1.0, каждая часть = 0.1
  // Для рейтинга 3.4: 3 полные + 4/10 четвертой
  const totalParts = Math.round(safe * 10); // Всего частей (0-50)
  const fullStars = Math.floor(totalParts / 10); // Полные звезды
  const partialParts = totalParts % 10; // Части последней звезды (0-9)
  const emptyStars = 5 - fullStars - (partialParts > 0 ? 1 : 0);
  const partialPercent = (partialParts / 10) * 100; // Процент заполнения частичной звезды

  return (
    <div className="flex items-center gap-1.5">
      <div className="flex items-center gap-0.5">
        {Array.from({ length: fullStars }).map((_, i) => (
          <Star
            key={`f-${i}`}
            size={starSize}
            fill="rgb(234 179 8)"
            color="rgb(234 179 8)"
          />
        ))}
        {partialParts > 0 && (
          <div className="relative">
            <Star
              size={starSize}
              fill="currentColor"
              color="hsl(var(--muted-foreground))"
            />
            <div
              className="absolute inset-0 overflow-hidden"
              style={{ width: `${partialPercent}%` }}
            >
              <Star
                size={starSize}
                fill="rgb(234 179 8)"
                color="rgb(234 179 8)"
              />
            </div>
          </div>
        )}
        {Array.from({ length: emptyStars }).map((_, i) => (
          <Star
            key={`e-${i}`}
            size={starSize}
            fill="currentColor"
            color="hsl(var(--muted-foreground))"
          />
        ))}
      </div>
      {variant === "full" && (
        <span className={`${textSize} text-muted-foreground leading-tight`}>
          {safe.toFixed(1)}{" "}
          {reviews_count !== undefined &&
            reviews_count !== null &&
            `(${reviews_count} ${getReviewWord(reviews_count)})`}
        </span>
      )}
      {variant === "min" && (
        <span className={`${textSize} text-muted-foreground leading-tight`}>
          {safe.toFixed(1)}{" "}
          {reviews_count !== undefined &&
            reviews_count !== null &&
            `(${reviews_count})`}
        </span>
      )}
    </div>
  );
}
